import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Typography,
} from "@mui/material";
import { toMoney } from "../../util/Utils";
import { Box, TextField } from "@mui/material";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function DiscountCodeDetails(props) {
  const { isSmall } = useBreakpoints();

  return (
    <Dialog
      PaperProps={{
        elevation: 1,
      }}
      fullWidth
      maxWidth="sm"
      open={props.openDialoge.show}
      onClose={() =>
        props.setOpenDialoge({ ...props.openDialoge, show: false })
      }
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle color="secondary" id="alert-dialog-title">
        جزئیات گزارش کد تخفیف {props.openDialoge.model?.dayname}
      </DialogTitle>
      <DialogContent>
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="کد تخفیف"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={
                props.openDialoge.model?.discountCode
                  ? toMoney(props.openDialoge.model?.discountCode)
                  : "0"
              }
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="تعداد سفارشات"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={
                props.openDialoge.model?.orderCount
                  ? toMoney(props.openDialoge.model?.orderCount)
                  : 0
              }
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="تاریخ شروع"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                readOnly: true,
              }}
              value={
                props.openDialoge.model?.startDate
                  ? props.openDialoge.model?.startDate
                  : 0
              }
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="تاریخ پایان"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                readOnly: true,
              }}
              value={
                props.openDialoge.model?.endDate
                  ? props.openDialoge.model?.endDate
                  : 0
              }
              variant="filled"
            />
          </Box>

          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="مجموع قیمت سفارشات"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={
                props.openDialoge.model?.totalOrderCost
                  ? toMoney(props.openDialoge.model?.totalOrderCost)
                  : 0
              }
              variant="filled"
            />
          </Box>

          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="مجموع تخفیف"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={
                props.openDialoge.model?.totalOrderDiscount
                  ? toMoney(props.openDialoge.model?.totalOrderDiscount)
                  : 0
              }
              variant="filled"
            />
          </Box>

          <Box
            sx={{ display: "flex", justifyContent: "center" }}
            gridColumn="span 12"
          >
            <Button
              onClick={() =>
                props.setOpenDialoge({ ...props.openDialoge, show: false })
              }
              color="secondary"
              variant="outlined"
            >
              بستن
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
